import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../../common_comp/Layout/Layout";

function OpenPolicy() {
  return (
    <>
      <Layout>
        <Container className="mt-5 px-4">
          <Row className="g-5 pt-3">
            <Col lg={10} md={10} sm={12} className="mx-auto">
              <h2 className="fw-bold mb-4">Open Access Policy</h2>
              <p className="joab-common-para mb-3">
                The <i>Journal of Applied Bioanalysis</i> follows a <b>Gold Open Access publishing model</b>. All articles published in this journal are <b>freely and permanently accessible online immediately upon publication</b>, ensuring the widest possible dissemination of research to global readers.
              </p>

              <h2 className="fw-bold mb-4">License and Copyright</h2>
              <p className="joab-common-para mb-3">
                All articles are published under the terms of the <b>Creative Commons Attribution 4.0 International License </b><br/>
                <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">
                (CC BY 4.0)
                </a>
              </p>
              <p className="joab-common-para mb-3">
                Under this license:
                <ul>
                  <li>Authors retain full copyright of their articles.</li>
                  <li>Readers are free to read, download, copy, distribute, print, search, and link to the full texts.</li>
                  <li>Proper credit must be given to the original authors and source.</li>
                </ul>
              </p>

              <h2 className="fw-bold mb-4">Article Processing Charges (APCs)</h2>
              <p className="joab-common-para mb-3">
                To cover the costs of open access publishing, an <b>Article Processing Charge (APC)</b> may be applied after acceptance.
                <ul>
                  <li>
                    <b>Current APC Details:</b> <a href="https://journalofappliedbioanalysis.com/information/for-authors-2/5-funding-of-apcs-and-bpcs" target="_blank" rel="noopener noreferrer">https://journalofappliedbioanalysis.com/information/for-authors-2/5-funding-of-apcs-and-bpcs</a>
                  </li>
                  <li><b>No submission charges</b> apply.</li>
                  <li><b>Waivers and discounts</b> are available – see our <a href="#">Waiver Policy</a>.</li>
                </ul>
                <i>Editorial decisions are made independently of payment status to maintain fairness and academic integrity.</i>
              </p>

              <h2 className="fw-bold mb-4">Why Open Access?</h2>
              <p className="joab-common-para mb-3">
                <ul>
                  <li>Promotes global access to research without paywalls</li>
                  <li>Increases citation, visibility, and impact</li>
                  <li>Complies with funding agency mandates for open access</li>
                </ul>
              </p>
            </Col>
          </Row>
        </Container>
      </Layout>
    </>
  );
}

export default OpenPolicy; 